module.exports = __webpack_public_path__ + "img/upfail.45d04725.svg";